import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import SimpleBar from 'simplebar';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { horizontalLoop } from './horizontalLoop';

// Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Navigation]);

// GSAP
window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);
window.ScrollTrigger = ScrollTrigger;
window.horizontalLoop = horizontalLoop;

const initParallaxMedia = () => {
	const parallaxContainers = document.querySelectorAll('[data-parallax-container]');

	if (!parallaxContainers.length ) {
		return;
	}

	parallaxContainers.forEach((container) => {
		const media = container.querySelector('img, video');

		if (!media) {
			return;
		}

		gsap.fromTo(
			media,
			{ yPercent: -10 },
			{
				yPercent: 10,
				ease: 'none',
				scrollTrigger: {
					trigger: container,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			},
		);
	});
};

initParallaxMedia();

const updateProductDetailScrollbars = (root = document) => {
	const scrollAreas = root.querySelectorAll('.js-product-detail-scrollbar');

	scrollAreas.forEach((scrollArea) => {
		const instance = SimpleBar.instances.get(scrollArea);

		if (instance) {
			instance.recalculate();
			return;
		}

		new SimpleBar(scrollArea, {
			autoHide: false,
		});
	});
};

window.updateProductDetailScrollbars = updateProductDetailScrollbars;
updateProductDetailScrollbars();

// Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();
